import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from '@redux-devtools/extension';
import createSagaMiddleware from "redux-saga";
import {thunk} from "redux-thunk";
import rootSaga from "./rootSaga";
import rootReducer from "./rootReducer";

// Create Saga middleware
const sagaMiddleware = createSagaMiddleware();

// Setup middleware
const middleware = [thunk, sagaMiddleware];

// Create Redux store
const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

// Run Saga middleware
sagaMiddleware.run(rootSaga);

export default store;
